import React, { useRef } from 'react';

import { FormControl, Input } from '@rbilabs/universal-components';
import { StyleSheet, View } from 'react-native';
import { Typography } from 'ucl/components/text/Typography';

import { t } from 'state/intl/translations';
import { primitive } from 'styles/constants';

import { useCheckoutValidation } from '../../../hooks/use-checkout-validation';
import { IVehicleDescriptionProps } from '../types';

const DescriptionInput = Input.withConfig({
  width: 'full',
  borderWidth: 1,
  borderColor: primitive.$blackOpacity30,
  borderStyle: 'solid',
  borderRadius: 4,
  style: {
    shadowColor: primitive.$shadowColor,
    shadowOffset: {
      width: 0,
      height: 0.5,
    },
    shadowRadius: 1.5,
    shadowOpacity: 1,
  },
  color: primitive.$bbqBrown,
  fontFamily: 'body',
  fontSize: 'md',
  placeholderTextColor: primitive.$blackOpacity50,
  paddingTop: '$3',
  paddingBottom: '$3',
  paddingLeft: '$4',
  paddingRight: '$4',
});

const DescriptionContainer = FormControl.withConfig({
  borderWidth: 0,
  borderColor: 'black',
  borderStyle: 'solid',
  marginTop: '$4',
  marginBottom: 0,
});

export const VehicleDescriptionMobilePickup: React.FC<React.PropsWithChildren<
  IVehicleDescriptionProps
>> = ({ onChange, value }) => {
  const inputRef = useRef<HTMLInputElement>(null);
  const { validate } = useCheckoutValidation();
  const checkoutErrors = validate();
  const errors = checkoutErrors.filter(error => error.placement === 'vehicleDescription');
  const isValid = errors.length === 0;

  const handleChange = (description: string) => {
    const value = description?.trimStart();
    onChange({ value, hasError: !isValid });
  };

  return (
    <DescriptionContainer>
      <View style={styles.titleContainer}>
        <Typography style={styles.titleText}>{t('mobilePickupVehicleTitle')}</Typography>
        <Typography>({t('required')})</Typography>
        <Typography style={styles.asteriskText}>*</Typography>
      </View>
      <DescriptionInput
        testID="vehicle-description"
        placeholder={t('mobilePickupVehicleDescriptionPlaceholder')}
        onChangeText={handleChange}
        value={value}
        ref={inputRef}
      />
      {!isValid ? (
        <Typography style={styles.errorMessage}>{errors[0].message}</Typography>
      ) : (
        <Typography style={styles.descriptionHelp}>
          {t('mobilePickupVehicleDescription')}
        </Typography>
      )}
    </DescriptionContainer>
  );
};

const styles = StyleSheet.create({
  titleContainer: {
    display: 'flex',
    flexDirection: 'row',
    alignItems: 'baseline',
    marginBottom: 8,
  },
  titleText: {
    fontSize: 16,
    fontWeight: 'bold',
    fontFamily: primitive.fontFamily.$headers,
    marginRight: 8,
  },
  asteriskText: {
    color: primitive.$error,
  },
  errorMessage: {
    color: primitive.$error,
    fontSize: 12,
  },
  descriptionHelp: {
    fontSize: 12,
  },
});
